export const DropdownEnum = {
  IncidentType: 1001,
  IncidentSeverity: 1002,
  IncidentStatus: 1003,
  ToolboxTalkStatus: 1004,
  Make: 1101,
  Model: 1102,
  VehicleType: 1103,
  FuelType: 1104,
  RegistrationState: 1105,
  InsuranceProvider: 1106,
  VehicleStatus: 1107,
  RegisterCompany: 1112,
  RegistrationCertificate: 1108,
  InsuranceDocument: 1109,
  RoadworthyCertificate: 1110,
  OtherDocument: 1111,
  ClientNoteType: 1201,
  ExternalCompany: 1202,
  TradeType: 1203,
  Company: 1301,
  Suburb: 1302,
  City: 1303,
  State: 1304,

  // Selection Module Dropdown Entities
  SelectionCategory: 1401,
  SelectionProduct: 1402,
  SelectionSupplier: 1403,
  SelectionProductCode: 1404,
  SelectionRange: 1405,
  SelectionStatus: 1406,
  SelectionMainCategory: 1407,
  JobSelectionStatus: 1408,
  SelectionType: 1409,
  // 1401-1403 are reserved by the backend's JobFilterDropdownEnum (JobGroup/JobType/ContractType) —
  // do not reuse those values here, they'd share DropdownOption rows with that unrelated feature.
  Milestone: 1501,
  Phase: 1502,

  // User Management
  VisaStatus: 1601,
};
